import "../css/users.css";

import React from "react";
import Breadcrumb from "../components/breadcrumb";
import ModalForm from "../components/modalForm";
import { Helmet, HelmetProvider } from 'react-helmet-async';

const KeyValues = () => {  

    let breadcrumbItens = [
        {
            text: "Home",
            route: "/"
        },
        {
            text: "Key Values",
            route: "#"
        }
    ];

    let inputs = [
            {              
                type: "select",
                name: "type",
                label: "Tipo",
                isRequired: true,
                value: 'aquisicao',
                options:[
                    {
                        text: "Aquisição",
                        value: "aquisicao"
                    },
                    {
                        text: "Retenção",
                        value: "retencao"
                    }
                ]
            },
            {              
                type: "text",
                name: "name",
                label: "Name",
                isRequired: true
            },
            {              
                type: "number",
                name: "value_id",
                label: "Value ID",
                isRequired: true
            }
    ];

    return (
        <div className="container">
            <ModalForm input={inputs} action="save-key-values" elemId="keyValueModal" isEdit={false} title="Key Values" />
            <ModalForm input={inputs} action="update-key-values" elemId="editKeyValueModal" isEdit={true} title="Key Values" />

            <div className="defaultContainer">
               
                <div className="row">
                    <div className="col-12">
                        <h1 className="h1">Key Values
                            <button type="button" className="btn btn-sm btn-add" data-bs-toggle="modal" data-bs-target="#keyValueModal">
                                <span className="material-symbols-outlined transition">add_box</span>
                            </button>
                        </h1>
                        <Breadcrumb links={breadcrumbItens} />
                    </div>
                </div>
                <br />
                
                <div className="row">
                    <div className="col-12">
                        <table id="dtKeyValues" className="dataTables cell-border table table-bordered table-striped" style={{width:"100%"}}>
                            <thead>
                                <tr className="thead-dark">                                  
                                    <th>Tipo</th>
                                    <th>Name</th>
                                    <th>Value ID</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody></tbody>
                            <tfoot></tfoot>
                        </table>    
                    </div>
                </div> 

            </div>
            <HelmetProvider>
                <Helmet>
                    <script src="./js/checkPermissions.js" type="text/javascript"></script>    
                    <script src="./js/datatables/key-values.js" type="text/javascript"></script>
                </Helmet>
            </HelmetProvider> 
        </div>
    );
}

export default KeyValues;